import React from 'react'
import Introsection from '../organisms/CharandFieldssections/Introsection'
import Content from '../organisms/CharandFieldssections/Content'
import Footer from '../organisms/Footersections/Footer'

export default function Pagetemplate({title,introdata,contentData,defaultChecked}) {
  // console.log('Pagetemplate', contentData)
  return (
    <div>
      <Introsection introdata={introdata} defaultChecked={defaultChecked}/>
      <Content title={title} contentData={contentData}/>
      <Footer/>
    </div>
  )
}
